import { render, staticRenderFns } from "./DetailsCarComponent.vue?vue&type=template&id=5e76b9b6&"
import script from "./DetailsCarComponent.vue?vue&type=script&lang=js&"
export * from "./DetailsCarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QExpansionItem,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QIcon,QPageSticky,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QExpansionItem,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QIcon,QPageSticky,QCardSection})
